import script from "./NewsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsView.vue?vue&type=script&lang=ts&setup=true"

import "./NewsView.vue?vue&type=style&index=0&id=caf9af58&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf9af58"]])

export default __exports__